/** Shared, synchronous sign-out fence for device-local degree progress. */
export const DEGREE_PROGRESS_CACHE_PREFIX = 'scarlet-degree-progress:v6:';
export const LEGACY_PROGRESS_KEYS = ['degreeProgressCache', 'degreeProgressHash', 'degreeProgressCacheVersion'];

let storageGeneration = 0;

export function currentDegreeProgressStorageGeneration(): number {
  return storageGeneration;
}

export function clearDegreeProgressSnapshotKeys(): void {
  storageGeneration += 1;
  try {
    for (let index = localStorage.length - 1; index >= 0; index -= 1) {
      const key = localStorage.key(index);
      if (key && (key.startsWith(DEGREE_PROGRESS_CACHE_PREFIX) || LEGACY_PROGRESS_KEYS.includes(key))) {
        localStorage.removeItem(key);
      }
    }
  } catch { /* Storage can be disabled. The generation still fences in-flight work. */ }
}
